<template>
  <div>
    <el-tooltip effect="light" :disabled="tooltipDisabled">
      <template slot="content">
        {{ tooltipContent }}
      </template>

      <div class="label" ref="label" :class="labelClass" @click="labelClick">
        {{ value }}
      </div>
    </el-tooltip>

    <el-dialog
      v-if="popupVisible"
      :title="popupTitle"
      :visible="true"
      :modal="false"
      :modal-append-to-body="false"
      :before-close="closePopup"
    >
      <vue-json-pretty
        v-if="jsonValue"
        :data="jsonValue"
        class="json-wrapper"
      ></vue-json-pretty>

      <div v-else>
        {{ value }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'OverflowTooltip',

  components: {
    VueJsonPretty
  },

  props: {
    value: {
      required: true
    }
  },

  data() {
    return {
      truncated: false,
      popupVisible: false
    }
  },

  mounted() {
    this.update()

    window.addEventListener('resize', () => {
      this.update()
    })
  },

  computed: {
    tooltipContent() {
      if (this.valueIsJson) {
        return this.$t('OverflowTooltip_ClickToExpand')
      } else {
        return this.value
      }
    },

    tooltipDisabled() {
      return !this.truncated && !this.valueIsJson
    },

    valueIsJson() {
      if (typeof this.value === 'object') {
        return true
      } else {
        return this.value && (this.value[0] === '{' || this.value[0] === '[')
      }
    },

    jsonValue() {
      if (typeof this.value === 'object') {
        return this.value
      } else {
        try {
          return JSON.parse(this.value)
        } catch (e) {
          return null
        }
      }
    },

    labelClass() {
      if (this.valueIsJson) {
        return 'json'
      } else {
        return 'plain'
      }
    },

    popupTitle() {
      if (this.jsonValue) {
        return 'JSON'
      } else {
        return 'Invalid JSON'
      }
    }
  },

  methods: {
    update() {
      this.truncated =
        this.$refs.label.scrollWidth > this.$refs.label.clientWidth
    },

    showPopup() {
      this.popupVisible = true
    },

    closePopup() {
      this.popupVisible = false
    },

    labelClick() {
      if (this.valueIsJson) {
        this.showPopup()
      }
    }
  }
}
</script>

<style scoped>
.label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.label.json {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/OverflowTooltip.vue